import { render, staticRenderFns } from "./ChatComponent.vue?vue&type=template&id=b1c44a62"
import script from "./ChatComponent.vue?vue&type=script&lang=js"
export * from "./ChatComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatComponent.vue?vue&type=style&index=0&id=b1c44a62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports